<template>
  <div
    id="app"
    class="is-full-height"
  >
    <template v-if="$browserDetect.isIE">
      <div
        class="message is-marginless"
        :class="$browserDetect.meta.version < 11 ? 'is-danger' : 'is-warning'"
      >
        <div class="message-body">
          <b>Important:</b> We have received reports of issues using this application with Internet explorer. While we work on fixing these issues, please consider using a <a
            href="https://browsehappy.com/"
            target="_blank"
          ><b>modern browser</b><span class="icon"><i class="fad fa-external-link" /></span></a>.
        </div>
      </div>
    </template>
    <router-view />
  </div>
</template>
<script>

import Vue from 'vue';
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

export default {
  name: "App",
  created() {
    this.$store.dispatch('login/silentlyLoginTimeout');
  },
};
</script>
<style lang='scss'>
  @import '@/assets/scss/app.scss';
  .main-loading {
    &:after {
      content: '';
      width: 100%;
      height: calc(100% - 42px);
      position: absolute;
      top: 42px;
      left: 0;
      background-color: rgba(#fff, 0.5);
      z-index: 999;
    }
    overflow: hidden;
    max-height: 100vh !important;
  }
  .phila-loading {
    z-index: 9999999;
  }
</style>